module.exports = __webpack_public_path__ + "img/img13.e355f0e2.svg";